import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Icon } from 'semantic-ui-react';
import { useIntl } from 'react-intl';

const CopyIcon = ({ icon = 'copy outline', messageId = 'actions.copy.clipboard', text }) => {
  const intl = useIntl();
  return (
    <CopyToClipboard text={text}>
      <Icon link name={icon} className="primary" title={intl.formatMessage({ id: messageId })} />
    </CopyToClipboard>
  );
};

export default CopyIcon;
